<template>
    <div class="footer-container">
        <p @click="router.push('/about')">About Us</p>
        <p><a href="mailto:youremail@example.com">Contact Us</a></p>
        <p @click="router.push('/privacy')">Terms of Service</p>
        <p @click="router.push('/AIPolicy')">AI Policy</p>
    </div>
</template>

<script>
import { useRouter } from 'vue-router';

export default {
  name: 'FooterBar',
  setup() {
    const router = useRouter();
    return { router };
  }
};

</script>

<style scoped>
.footer-container {
    background-color: #fffff8;
    padding: 5px;
    text-align: center;
    color: #6c757d;
    z-index: 10;
    height: 2rem;
    display: inline-block;
}

.footer-container p {
  display: inline;
  margin: 0;
  cursor: pointer;
  font-size: 0.9rem;
}

.footer-container p + p::before {
  content: "\00a0\00a0\00a0•\00a0\00a0\00a0";
}

.footer-container a {
  color: inherit;
  text-decoration: none;
}
</style>